import { useEffect, useRef } from 'react';

// custom hook to observe user click declared here
const useUserClickObserver = (
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
) => {
  // integration of react hooks here
  const selectRef = useRef<HTMLElement>(null);

  // checking where user have clicked
  useEffect(() => {
    // handler function to collapse visible menu on clicking outside
    const clickOutsideHandler = (event: MouseEvent) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        setVisible(false);
      }
    };

    document.addEventListener('click', clickOutsideHandler);

    return () => {
      document.removeEventListener('click', clickOutsideHandler);
    };
  }, [setVisible]);

  return selectRef;
};

export default useUserClickObserver;
